import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  createFlag as createFlagService,
  updateFlag as updateFlagService,
  deleteFlag as deleteFlagService, 
  getFlags as getFlagsService
} from "../../services/tenant/flag.service";
import { validate } from "../../utils";
import { handlerErrorV2 } from "../../utils/errors";
import { updateFlagsList, updateFlagsListMethod } from "../../store/actions/tenant.actions";
import isEmpty from 'lodash/isEmpty';

const useFlags = () => {
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [errors, setErrors] = useState({});
  
  const getFlags = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getFlagsService();
      dispatch(updateFlagsList(response?.data || []));
    } catch (error) {
      setErrors({ message: error.message || 'An error ocurred'});
    } finally {
      setIsLoadingList(false);
    }
  }, []);

  useEffect(() => {
    getFlags();
  }, []);

  const validateForm = (form) => {
    const fieldRules = {
      name: 'required'
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      return { error: true, ...errors }
    }

    return { error: false }
  }

  const createFlag = async (form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await createFlagService(form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateFlagsListMethod('POST', response.data));
        enqueueSnackbar('Flag created successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const updateFlag = async (flagId, form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await updateFlagService(flagId, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateFlagsListMethod('PUT', response.data));
        enqueueSnackbar('Flag updated successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const deleteFlag = async (flagId) => {
    try {
      const response = await deleteFlagService(flagId);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateFlagsListMethod('DELETE', flagId));
        enqueueSnackbar('Flag deleted successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  return {
    errors,
    isLoadingList,
    getFlags,
    createFlag,
    updateFlag,
    deleteFlag
  }
};

export default useFlags;